import React, { createContext, useContext, useEffect, useState } from "react";
import { getSettings } from "../services/settingsService";

const SiteSettingsContext = createContext({ settings: {}, loading: true });

/**
 * Admin panel-এর "Site Content" পেজ থেকে upload করা ছবিগুলো এখানে fetch
 * করা হয় (একবার, অ্যাপ লোড হওয়ার সময়)। কোনো key-এর জন্য admin ছবি upload
 * না করলে API null পাঠায় — তখন `useSiteImage` bundled default ছবিটাই
 * ব্যবহার করে, তাই ভাঙা ছবি কখনো দেখা যাবে না।
 */
export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getSettings()
      .then((data) => setSettings(data.settings || {}))
      .catch(() => setSettings({}))
      .finally(() => setLoading(false));
  }, []);

  return (
    <SiteSettingsContext.Provider value={{ settings, loading }}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

export const useSiteSettings = () => useContext(SiteSettingsContext);

// একটা নির্দিষ্ট slot-এর ছবি চাই? admin upload করা থাকলে সেটা, না থাকলে
// bundled default (fallbackImage) — এভাবে ব্যবহার করুন:
// const heroImg = useSiteImage("home_hero_image_1", BannerImg);
export function useSiteImage(key, fallbackImage) {
  const { settings } = useSiteSettings();
  return settings[key] || fallbackImage;
}
